export const SET_LINK_RECORD = 'set-link-record';
export const SET_PET_POOJA_ITEMS = 'set-pet-pooja-items';
export const SET_PET_POOJA_VARIANTS = 'set-pet-pooja-variants';
export const SET_LINKED_ITEMS = 'set-linked-items';
export const SET_DISCARD_CHANGES = 'set-discard-changes';
export const SET_UNLINK_ITEMS = 'set-unlink-items';
export const SET_PET_POOJA_ADDONS = 'set-pet-pooja-addons';
export const SET_PET_POOJA_TAXES = 'set-pet-pooja-taxes';
export const SET_PETPOOJA_RESTAURANT = 'set-pet-pooja-restaurant';
